<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="variableArrRules" class="sky-server-config">
    <div
      :class="['sky-server-config__item', 'sk-font--B', isFill(item) && 'active']"
      v-for="(item, index) in variableArr"
      :key="index"
    >
      <i class="el-icon-arrow-right" />
      <el-input
        v-if="configValueOneType == 'string'"
        :ref="item.configValueOne"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        v-model="item.configValueOne"
        :placeholder="$t(configValueOnePlaceholder)"
      >
      </el-input>
      <el-input
        v-else-if="configValueOneType == 'number'"
        type="number"
        :ref="item.configValueOne"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        v-model="item.configValueOne"
        :placeholder="$t(configValueOnePlaceholder)"
        :controls="false"
        :min="0"
      >
      </el-input>
      <i v-if="configValueTwoShow" class="el-icon-arrow-right" />
      <el-input
        v-if="configValueTwoType == 'string' && configValueTwoShow"
        :ref="item.configValueTwo"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        v-model="item.configValueTwo"
        :placeholder="$t(configValueTwoPlaceholder)"
      >
      </el-input>
      <el-input
        v-else-if="configValueTwoType == 'number' && configValueTwoShow"
        type="number"
        :ref="item.configValueTwo"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        v-model="item.configValueTwo"
        :placeholder="$t(configValueTwoPlaceholder)"
        :controls="false"
        :min="0"
      >
      </el-input>
      <i v-if="configValueThreeShow" class="el-icon-arrow-right" />
      <el-input
        v-if="configValueThreeType == 'string' && configValueThreeShow"
        :ref="item.configValueThree"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        v-model="item.configValueThree"
        :placeholder="$t(configValueThreePlaceholder)"
      >
      </el-input>
      <el-input
        v-else-if="configValueThreeType == 'number' && configValueThreeShow"
        type="number"
        :ref="item.configValueThree"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        v-model="item.configValueThree"
        :placeholder="$t(configValueThreePlaceholder)"
        :controls="false"
        :min="0"
      >
      </el-input>
      <i v-if="configValueFourShow" class="el-icon-arrow-right" />
      <el-input
        v-if="configValueFourType == 'string' && configValueFourShow"
        :ref="item.configValueFour"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        v-model="item.configValueFour"
        :placeholder="$t(configValueFourPlaceholder)"
      >
      </el-input>
      <el-input
        v-else-if="configValueFourType == 'number' && configValueFourShow"
        type="number"
        :ref="item.configValueFour"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        v-model="item.configValueFour"
        :placeholder="$t(configValueFourPlaceholder)"
        :controls="false"
        :min="0"
      >
      </el-input>
      <i class="sk-icon-remove sk-font--B" @click="handleDelete(index)"></i>
    </div>

    <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="handleAdd">
      添加配置
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import {
  Select,
  Option,
  Input,
  OptionGroup,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  InputNumber
} from 'element-ui'

export default {
  name: 'SkyServerConfig',
  inject: ['rootView', 'elForm'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button,
    [OptionGroup.name]: OptionGroup,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [InputNumber.name]: InputNumber
  },
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    configKey: {
      type: String,
      default: 'CPU'
    },
    configValueOnePlaceholder: {
      type: String,
      default: '型号'
    },
    configValueTwoPlaceholder: {
      type: String,
      default: '主频（GHz）'
    },
    configValueThreePlaceholder: {
      type: String,
      default: '核数'
    },
    configValueFourPlaceholder: {
      type: String,
      default: '线程'
    },
    configValueOneType: {
      type: String,
      default: 'string'
    },
    configValueTwoType: {
      type: String,
      default: 'string'
    },
    configValueThreeType: {
      type: String,
      default: 'string'
    },
    configValueFourType: {
      type: String,
      default: 'string'
    },
    configValueOneRequired: {
      type: Boolean,
      default: true
    },
    configValueTwoRequired: {
      type: Boolean,
      default: true
    },
    configValueThreeRequired: {
      type: Boolean,
      default: true
    },
    configValueFourRequired: {
      type: Boolean,
      default: true
    },
    configValueOneShow: {
      type: Boolean,
      default: true
    },
    configValueTwoShow: {
      type: Boolean,
      default: true
    },
    configValueThreeShow: {
      type: Boolean,
      default: true
    },
    configValueFourShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      variableArr: [],
      loading: false
    }
  },
  mounted() {},
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        let hasError = false
        if (this.variableArr.length) {
          for (const data of this.variableArr) {
            if (!this.isFill(data)) {
              hasError = true
              callback(new Error(this.$t('请输入未填项')))
            }
          }
        }
        if (!hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      if (this.value.length) {
        this.handleFill(value)
      }
    },
    variableArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return (
        (!this.configValueOneRequired || (this.configValueOneRequired && item.configValueOne)) &&
        (!this.configValueTwoRequired || (this.configValueTwoRequired && item.configValueTwo)) &&
        (!this.configValueThreeRequired || (this.configValueThreeRequired && item.configValueThree)) &&
        (!this.configValueFourRequired || (this.configValueFourRequired && item.configValueFour))
      )
    },
    handleAdd() {
      this.variableArr.push({
        configKey: this.configKey,
        configValueOne: null,
        configValueTwo: null,
        configValueThree: null,
        configValueFour: null
      })
    },
    handleFill(value) {
      this.variableArr = value
    },
    handleDelete(index) {
      this.variableArr.splice(index, 1)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
